import { useEffect, useState } from 'react';

/**
 * An element's box, kept up to date as the page is resized or it changes size.
 *
 * Takes the element rather than a ref: a picture's frame arrives after the
 * skeleton it replaces, and an effect reading a ref cannot know when that
 * happened. Whoever wants this holds the element as state (see `useZoomPan`,
 * which already does, and the editors' popover).
 */
export function useBoxSize(element: HTMLElement | null): { width: number; height: number } {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!element) return;

    const read = () => setSize({ width: element.offsetWidth, height: element.offsetHeight });
    read();

    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(read);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return size;
}
